const colors = {
  primary: "#0f67fd", // Dark blue
  secondary: "#b40c31", // Dark red
  orange: "#f97316", // Orange
  white: "#ffffff",
  gray50: "#f9fafb", // Light gray
  gray300: "#d1d5db", // Medium gray
  lightBlue: "#66b3ff", // Slightly lighter blue
  lightGreen: "#66cc66", // Slightly lighter green
};

export default colors;
